import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

export function SuccessIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 24, width: 24 }}
      viewBox="0 0 24 24"
    >
      <path
        d="M14.913 8.534c.257-.325.73-.379 1.053-.121.325.257.379.73.121 1.053l-4.566 5.749c-.266.348-.685.547-1.124.534-.439-.013-.845-.236-1.08-.586l-1.43-2.018c-.238-.338-.158-.806.18-1.045.338-.24.806-.16 1.045.178l1.332 1.881 4.469-5.625zM12 21.187c-5.074 0-9.188-4.114-9.188-9.188 0-5.074 4.114-9.187 9.188-9.187 5.074 0 9.188 4.113 9.188 9.187 0 5.074-4.114 9.188-9.188 9.188zm0-1.5c4.246 0 7.688-3.442 7.688-7.688 0-4.245-3.442-7.687-7.688-7.687-4.246 0-7.688 3.442-7.688 7.687 0 4.246 3.442 7.688 7.688 7.688z"
        transform="translate(-16 -16) translate(16 16)"
      />
    </SvgIcon>
  );
}
